import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { Fauxdown } from '../../../concepts/text/Fauxdown';
import { BoardInfo } from '../../canvas/BoardInfo';
import { EditorSession } from '../../canvas/EditorSession';

const puncRegex = /[.!?]/;

const searchForStart = (text: string, mentionIndex: number) => {
    // Look for either a full stop or the start of the text, going back a max of 100 chars.
    for (let i = mentionIndex; i > 0; i--) {
        if (puncRegex.test(text[i])) {
            return i + 1;
        }
    }
    return 0;
};

const searchForEnd = (text: string, mentionIndex: number, mentionLength: number) => {
    // Look for either a full stop or the end of the text, going forward a max of 200 chars.
    for (let i = mentionIndex + mentionLength; i < Math.min(text.length, mentionIndex + mentionLength + 200); i++) {
        if (puncRegex.test(text[i])) {
            return i + 1;
        }
    }
    return text.length;
};

const toQuote = (text: string, mentionIndex: number, mentionLength: number) => {
    const start = searchForStart(text, mentionIndex);
    const end = searchForEnd(text, mentionIndex, mentionLength);
    const value = text.slice(start, end).trim();
    return value;
};

export const submitMentions = defineCommand(
    'submitMentions',
    null,
    async (cc, [targetIds]: [string[]]) => {

        const api = cc.resolve(ApiClient);
        const objects = cc.resolve(ObjectManager);
        const subjects = targetIds.map(x => objects.getMaybe(x)).filter(x => !!x?.alive);
        const board = cc.resolve(EditorSession).get(BoardInfo);

        const mentions = subjects.flatMap(x =>
            Fauxdown.parseMentions(x.toText()).map(m => ({
                userId: m.toId,
                senderId: m.fromId,
                tag: m.tag,
                objectId: x.id,
                objectType: x.type,
                quote: toQuote(x.toText(), m.index, m.length),
            })));

        if (mentions.length > 0) {
            await api.exec(v2.boards.mentions.notify({
                boardId: board.id,
                mentions,
            }));
        }
    }
);

export const inMentionCommands = () => inCommands(submitMentions);
